import * as React from "react";

import { Property } from "../../../../types/property";

export const ExistingOccupierPropertyDetails: React.FC<{ property: Property }> = () => {
  return <span></span>;
};
